'use client';

import React from 'react';
import Link from 'next/link';
import { HiOutlineCursorClick } from '@react-icons/all-files/hi/HiOutlineCursorClick';
import { HiOutlineColorSwatch } from '@react-icons/all-files/hi/HiOutlineColorSwatch';
import { HiOutlinePhotograph } from '@react-icons/all-files/hi/HiOutlinePhotograph';
import { HiOutlineStar } from '@react-icons/all-files/hi/HiOutlineStar';
import { HiOutlineGlobe } from '@react-icons/all-files/hi/HiOutlineGlobe';
import { HiOutlineQrcode } from '@react-icons/all-files/hi/HiOutlineQrcode';
import { HiOutlineDesktopComputer } from '@react-icons/all-files/hi/HiOutlineDesktopComputer';
import { HiOutlineEye } from '@react-icons/all-files/hi/HiOutlineEye';
import {
  StyledHero,
  StyledHeroInner,
  StyledH1,
  StyledSubtitle,
  StyledToolGrid,
  StyledToolGridInner,
  StyledToolCard,
  StyledCardFooter,
  StyledUseToolLink,
  StyledComingSoonBadge,
} from './DesignHub.styles';

const TOOL_ICONS: Record<string, React.ReactNode> = {
  'css-button-generator': <HiOutlineCursorClick />,
  'color-palette-generator': <HiOutlineColorSwatch />,
  'box-shadow-generator': <HiOutlineStar />,
  'favicon-generator': <HiOutlinePhotograph />,
  'og-image-generator': <HiOutlineGlobe />,
  'logo-maker': <HiOutlineStar />,
  'brand-kit-generator': <HiOutlineColorSwatch />,
  'business-card-maker': <HiOutlinePhotograph />,
  'qr-code-generator': <HiOutlineQrcode />,
  'screenshot-beautifier': <HiOutlineDesktopComputer />,
  'accessibility-checker': <HiOutlineEye />,
};

interface ITool {
  slug: string;
  name: string;
  description: string;
  comingSoon?: boolean;
}

interface IProps {
  tools: ITool[];
}

export const DesignHub = ({ tools }: IProps) => {
  return (
    <>
      <StyledHero>
        <StyledHeroInner>
          <StyledH1>Free Design & Component Tools</StyledH1>
          <StyledSubtitle>
            Free CSS generators for buttons, color palettes, box shadows,
            favicons, and Open Graph images. No sign-up required.
          </StyledSubtitle>
        </StyledHeroInner>
      </StyledHero>

      <StyledToolGrid>
        <StyledToolGridInner>
          {tools.map((tool) => (
            <StyledToolCard key={tool.slug} available={!tool.comingSoon}>
              <div>
                <span className="tool-icon">{TOOL_ICONS[tool.slug]}</span>
                <h2>{tool.name}</h2>
                <p>{tool.description}</p>
              </div>
              <StyledCardFooter>
                {!tool.comingSoon ? (
                  <StyledUseToolLink as={Link} href={`/free-tools/website-tools/${tool.slug}`}>
                    Use Tool →
                  </StyledUseToolLink>
                ) : (
                  <StyledComingSoonBadge>Coming soon</StyledComingSoonBadge>
                )}
              </StyledCardFooter>
            </StyledToolCard>
          ))}
        </StyledToolGridInner>
      </StyledToolGrid>
    </>
  );
};
